module.exports = {
  apiBaseUrl:
    process.env.REACT_APP_ENV === 'production'
      ? 'https://cl.castlelearning.com/api'
      : process.env.REACT_APP_ENV === 'testing'
        ? 'https://qa.castlelearning.com/api'
        : process.env.REACT_APP_ENV === 'rc'  
          ? 'https://rc.castlelearning.com/api'
          : 'http://localhost:5001',

  nycRedirectUrl:
    process.env.REACT_APP_ENV === 'production'
      ? 'https://sso.castlelearning.com/signon/cl'
      : process.env.REACT_APP_ENV === 'rc'
        ? 'https://sso.castlelearning.com/signon/rc'
        : 'https://sso.castlelearning.com/signon/qa',

  castleSupportCode: 'castlesupport',

  googleAnalyticsKey:
    process.env.REACT_APP_ENV === 'production'
      ? 'G-NRV86QHPS2'
      : process.env.REACT_APP_ENV === 'testing'
        ? 'G-G6RBP0T548'
        : process.env.REACT_APP_ENV === 'rc'  
          ? ''
          : '',
          
  equalWebSiteKey: '92ecbd3cc82fcc2c76aa211592a94127',
  zenDeskKey:'e376e6f8-2ffe-40e1-b4e5-624fd7293cf5',
  defaultLoginPage: 'newCastle',
  classicLoginUrl:
    process.env.REACT_APP_ENV === 'production'
      ? 'https://cl.castlelearning.com/Review/CLO/Account/LogOn'
      : process.env.REACT_APP_ENV === 'testing'
        ? 'https://qa.castlelearning.com/Review/CLO/Account/LogOn'
        : process.env.REACT_APP_ENV === 'rc'  
          ? 'https://rc.castlelearning.com/Review/CLO/Account/LogOn'
          : 'http://localhost:90/CLO/Account/LogOn',

  googleClientId:'1036331443324-40ferq9h9blulrp9rg9ogj4mjbt8v0al.apps.googleusercontent.com'
};
